import api from '@/api/apiGPS';
// import jsonData from "@/temp/HistoryTrackingData.json";

export default {
    getGPSData(filter) {
        console.log(filter);
        // return { data: jsonData };
        return api.get(`/GPSData/GetGPSData?IMEI_No=${filter.imei}&fromDate=${filter.from}&toDate=${filter.to}&interval=1`);
        // return api.get(`/GPSData/GetGPSData?IMEI_No=358605084218340&fromDate=2020-02-14&toDate=2020-02-15&interval=1`);

    }
}